import React from "react";
import "./reset.css";
import "./App.css";
import { useState, useEffect } from "react";
import Header from "./components.js/Header";
import Skills from "./components.js/Skills";
import Profile from "./components.js/Profile";
import Footer from "./components.js/Footer";
import Projects from "./components.js/Projects";
import axios from "axios";

function App() {
  /*   const [projects, setProjects] = useState([]);
  console.log(projects);
  useEffect(() => {
    axios
      .get("http://localhost:3000/projects")
      .then((res) => {
        if (res.status === 200) {
          setProjects(res.data);
        }
        console.log(res.data);
      })
      .catch((error) => console.log(error));
  }, []); */

  const [isNightMode, setIsNightMode] = useState(false);
  useEffect(() => {
    const theme = localStorage.getItem("theme");
    if (theme === "dark") {
      setIsNightMode(true);
    }
  }, []);

  const toggleTheme = () => {
    setIsNightMode(!isNightMode);
    localStorage.setItem("theme", isNightMode ? "light" : "dark");
  };

  /*   const [isNightMode, setIsNightMode] = useState(false);

  const toggleTheme = () => {
    setIsNightMode(!isNightMode);
  }; */

  return (
    <>
      <Header toggleTheme={toggleTheme} isNightMode={isNightMode} />
      <Skills isNightMode={isNightMode} />
      <Profile isNightMode={isNightMode} />
      <Projects isNightMode={isNightMode} />
      <Footer isNightMode={isNightMode} />
    </>
  );
}

export default App;
